<c11n-card [hasImage]="true" class="hero-card">
  <img
    class="header-image"
    cardImage
    [src]="config.imageSrc"
    [alt]="config.imageAltKey | translate"
  />

  <h2 cardHeading class="heading-with-chip">
    {{ config.headingKey | translate }}
    <span *ngIf="config.chipLabelKey" class="heading-chip"
      ><c11n-chip
        [labelText]="config.chipLabelKey | translate"
        [color]="config.chipColor || 'yellow'"
      ></c11n-chip
    ></span>
  </h2>

  <div cardBody>
    <p class="mb-4">{{ config.bodyKey | translate }}</p>
    <ul class="check-list list-unstyled">
      <li *ngFor="let itemKey of config.checkItemKeys" class="d-flex align-items-start mb-3">
        <c11n-icon [name]="'success-fill'" [altText]="''" class="pe-1"></c11n-icon>
        <span>{{ itemKey | translate }}</span>
      </li>
    </ul>
  </div>

  <div cardAction class="card-actions">
    <c11n-button
      #cardAction
      [labelText]="config.buttonLabelKey | translate"
      variant="secondary"
      targetWindow="_blank"
      [fullWidth]="true"
      [href]="(config.buttonHref | translate) || null"
    ></c11n-button>
    <p class="text-center pt-2">
      <a c11n-link [routerLink]="config.linkRoute | langLink" class="c11n-text-md-bold">{{
        config.linkTextKey | translate
      }}</a>
    </p>
  </div>
</c11n-card>
